import loadable from "@loadable/component";
import { useInput } from "react-admin";
import { parsePolygon, type zone } from "../../models";
import { parsePoint } from "../../util";

const Map = loadable(() => import("../map"));

export const MapField = (props: any): JSX.Element => {
    const { field: point } = useInput({ source: props.source });
    const { field: zones } = useInput({ source: props.zones, defaultValue: [] });

    const [lng, lat] = parsePoint(point.value || "(0,0)");

    return (
        <Map center={{ lng, lat }} points={[{ lng, lat }]} polygons={(zones.value as zone[]).map(x => parsePolygon(x.geofence))} sx={props.sx}/>
    );
};



